import {Module} from '@fantasmagames/slot/src/common/Module';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {FreeSpinsView} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsView';
import {FreeSpinsBasicState} from '@fantasmagames/slot/src/modules/freespins/intro/states/FreeSpinsBasicState';
import {FreeSpinsIntroState} from '@fantasmagames/slot/src/modules/freespins/intro/states/FreeSpinsIntroState';
import {FreeSpinsOutroState} from '@fantasmagames/slot/src/modules/freespins/intro/states/FreeSpinsOutroState';
import {FreeSpinsProgressState} from '@fantasmagames/slot/src/modules/freespins/intro/states/FreeSpinsProgressState';
import {FreeSpinsRestoreIntroState} from '@fantasmagames/slot/src/modules/freespins/intro/states/FreeSpinsRestoreIntroState';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';

export class FreeSpinsModule extends Module<FreeSpinsView> {
	public static readonly BASIC_STATE: string = 'BASIC';
	public static readonly INTRO_STATE: string = 'INTRO';
	public static readonly INTRO_RESTORE_STATE: string = 'INTRO_RESTORE';
	public static readonly IN_PROGRESS_STATE: string = 'IN PROGRESS';
	public static readonly OUTRO_STATE: string = 'OUTRO';

	public addDebuggingComponent(): void {}

	public restore(): void {
		super.restore();

		if (this.logic.isFreeSpinsStarted) {
			if (this.logic.isFreeSpinsStarted && this.logic.freeSpinsPlayed === 0) {
				this.gotoState(FreeSpinsModule.INTRO_RESTORE_STATE);
			} else {
				this.gotoState(FreeSpinsModule.IN_PROGRESS_STATE);
			}
		}
	}

	protected enterFirstState(): void {
		this.changeStateTo(FreeSpinsModule.BASIC_STATE);
	}

	protected setupStates(): void {
		this.addState(new FreeSpinsBasicState(this, FreeSpinsModule.BASIC_STATE));
		this.addState(new FreeSpinsIntroState(this, FreeSpinsModule.INTRO_STATE));
		this.addState(new FreeSpinsOutroState(this, FreeSpinsModule.OUTRO_STATE));
		this.addState(new FreeSpinsRestoreIntroState(this, FreeSpinsModule.INTRO_RESTORE_STATE));
		this.addState(new FreeSpinsProgressState(this, FreeSpinsModule.IN_PROGRESS_STATE));
	}

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.FREE_SPINS_VIEW_MOBILE);
		} else {
			this.setView(Views.FREE_SPINS_VIEW);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.onCurrentStateHandle(FlowModuleEvents.FREESPINS_WIN);
		this.onCurrentStateHandle(FlowModuleEvents.FREE_SPINS_FINISHED);
		this.onCurrentStateHandle(FlowModuleEvents.FREESPINS_RETRIGGER_WIN);
		this.onCurrentStateHandle(FlowModuleEvents.CAN_SPIN);
		this.onCurrentStateHandle(WinPresentationEvents.INITIAL_ANIMATION_FINISHED);
		this.onCurrentStateHandle(ReelsEvents.REELS_FADING_OUT_FINISHED);
		this.onCurrentStateHandle(AvalancheReelsEvents.REELS_FADING_OUT_FINISHED);

		this.onCurrentStateHandle(FreeSpinsEvents.FREE_SPIN_STARTED);

		this.onViewEmitEvent(FreeSpinsView.SHOWING_WIN_SUMMARY_SCREEN, FreeSpinsEvents.SHOWING_WIN_SUMMARY_SCREEN);
		this.onViewEmitEvent(FreeSpinsView.FREE_SPINS_INTRO_TRANSITION_FINISHED, FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED);
		this.onViewEmitEvent(FreeSpinsView.FREE_SPINS_INFO_CONTINUE_CLICKED, FreeSpinsEvents.FREE_SPINS_CONTINUE_CLICKED);
		this.onViewEmitEvent(FreeSpinsView.FREE_SPINS_OUTRO_CONTINUE_CLICKED, FreeSpinsEvents.FREE_SPINS_OUTRO_CONTINUE_CLICKED);
		this.onViewEmitEvent(FreeSpinsView.RETRIGGER_STARTED, FreeSpinsEvents.FREE_SPINS_RETRIGGER_STARTED);
		this.onViewEmitEvent(FreeSpinsView.RETRIGGER_FINISHED, FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED);

		this.onViewCurrentStateHandle(FreeSpinsView.FREE_SPINS_INFO_CONTINUE_CLICKED);
		this.onViewCurrentStateHandle(FreeSpinsView.FREE_SPINS_OUTRO_FINISHED);
		this.onViewCurrentStateHandle(FreeSpinsView.FREE_SPINS_INTRO_FINISHED);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsModule.ts